// Dependencies
require("section/introduction");



/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/block/introduction/index.js
 ** module id = 143
 ** module chunks = 0 1
 **/